var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPointsIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 7.75C11 9.13075 9.88075 10.25 8.5 10.25C8.0525 10.25 7.632 10.1325 7.2685 9.92625C6.88353 9.70805 6.56331 9.39167 6.34047 9.00937C6.11763 8.62706 6.00015 8.19251 6 7.75C6 7.108 6.242 6.5225 6.6395 6.08C6.87377 5.81855 7.16058 5.60948 7.48118 5.46646C7.80177 5.32343 8.14895 5.24967 8.5 5.25C9.88075 5.25 11 6.36925 11 7.75Z",
    stroke: "url(#paint0_linear_32719_41343)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 3V5.25C8.14895 5.24967 7.80177 5.32343 7.48118 5.46646C7.16058 5.60948 6.87377 5.81855 6.6395 6.08C6.2269 6.53828 5.99902 7.13335 6 7.75C6.00033 7.895 6.01233 8.0365 6.036 8.1745C6.09899 8.5395 6.24223 8.88597 6.45536 9.1889C6.6685 9.49183 6.94623 9.74367 7.2685 9.92625C6.603 10.1275 5.7195 10.25 4.75 10.25C2.679 10.25 1 9.69025 1 9L1 3",
    stroke: "url(#paint1_linear_32719_41343)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 7C1 7.69025 2.679 8.25 4.75 8.25C5.20175 8.25 5.635 8.2235 6.036 8.1745M1 5C1 5.69025 2.679 6.25 4.75 6.25C5.439 6.25 6.08475 6.188 6.6395 6.08M9.5 7.75H8.5V6.75M8.5 3C8.5 3.69025 6.821 4.25 4.75 4.25C2.679 4.25 1 3.69025 1 3C1 2.30975 2.679 1.75 4.75 1.75C6.821 1.75 8.5 2.30975 8.5 3Z",
    stroke: "url(#paint2_linear_32719_41343)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_32719_41343",
    x1: 8.5,
    y1: 5.25,
    x2: 8.5,
    y2: 10.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.045,
    stopColor: "#D8DCF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#C4A4EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_32719_41343",
    x1: 4.75,
    y1: 3,
    x2: 4.75,
    y2: 10.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.045,
    stopColor: "#D8DCF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#C4A4EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_32719_41343",
    x1: 5.25,
    y1: 1.75,
    x2: 5.25,
    y2: 8.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.045,
    stopColor: "#D8DCF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#C4A4EF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointsIcon);
export default __webpack_public_path__ + "static/media/pointsIcon.92f79f391e8dcdaa6a970530c81be9da.svg";
export { ForwardRef as ReactComponent };